/**
 *  @class
 *  @function CollectionTabs
 */
if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    static get observedAttributes() {
      return ['selected-index'];
    }
    constructor() {
      super();
      this.scroller = this.querySelector('.collection-tabs__tabs');
      this.buttons = this.scroller.querySelectorAll('button');
      this.panels = this.querySelectorAll('.tab');
      this.activeClasses = (this.dataset.activeClass || '').split(' ').filter(Boolean);
      this.regularClasses = (this.dataset.regularClass || '').split(' ').filter(Boolean);
      this.tabsAdjustment = this.tabsAdjustment.bind(this);
    }

    connectedCallback() {
      this.selectedIndex = this.selectedIndex;

      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          this.selectedIndex = index;
        });
      });
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          this.selectedIndex = this.buttons.indexOf(event.target);
        });
      }

      this.tabsAdjustment();
      window.addEventListener('resize', this.tabsAdjustment);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.tabsAdjustment);
    }
    get selectedIndex() {
      return parseInt(this.getAttribute('selected-index')) || 0;
    }
    set selectedIndex(index) {
      this.setAttribute('selected-index', index);
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'selected-index' && oldValue !== null && oldValue !== newValue) {
        this.buttons[oldValue].classList.remove(...this.activeClasses);
        this.buttons[oldValue].classList.add(...this.regularClasses);
        this.buttons[newValue].classList.remove(...this.regularClasses);
        this.buttons[newValue].classList.add(...this.activeClasses);
        this.panels[parseInt(oldValue)].classList.remove('active');
        this.panels[parseInt(newValue)].classList.add('active');
      }
    }
    tabsAdjustment() {
      const buttonsWidth = Array.from(this.buttons).reduce((total, button) => (total += button.clientWidth), 0);

      if (buttonsWidth > this.scroller.clientWidth) {
        this.scroller.style.justifyContent = 'start';
        this.scroller.style.overflow = 'scroll';
        this.scroller.style.padding = '0';
        this.scroller.classList.remove('collection-tabs__separator');
      } else {
        this.scroller.style.justifyContent = this.dataset.alignment;
        this.scroller.style.padding = "";
        this.scroller.style.overflow = 'hidden';

        if (this.scroller.dataset.separator == 'true') {
          this.scroller.classList.add('collection-tabs__separator');
        }
      }
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}
